"use client";
import { PersonalitiesSectionProps } from "@/services/home/types";
import PersonalityCard from "./Card";
import { Shell } from "@/components/ui/shell";
import { Fade } from "@/components/ui/animations";
import Carpet from "@/components/ui/Carpet";

import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import { Lang } from "@/i18n/settings";

type Props = {
  data: PersonalitiesSectionProps;
  lang: Lang;
};

export default function PersonalityOfTheYear({ data, lang }: Readonly<Props>) {
  if (!data?.honoraries?.length) {
    return null;
  }

  const honoraries = data?.honoraries;

  return (
    <Carpet type="fade-dark">
      <Carousel
        opts={{
          align: "start",
          direction: lang === "ar" ? "rtl" : "ltr",
        }}
        className="w-full"
      >
        <Shell className="!py-[172px]">
          <div className="flex flex-col gap-8 md:gap-24">
            <div className="flex items-center justify-between gap-4">
              <h3 className="text-3xl tracking-[-1.44px] text-secondary sm:text-[38px] xl:text-[48px] ltr:font-playfair">
                {data?.title}
              </h3>
              <div className="flex items-center gap-4 rtl:flex-row-reverse">
                <CarouselPrevious className="relative h-10 w-10 md:h-12 md:w-12 3xl:h-[58px] 3xl:w-[58px]" />
                <CarouselNext className="relative h-10 w-10 md:h-12 md:w-12 3xl:h-[58px] 3xl:w-[58px]" />
              </div>
            </div>

            <CarouselContent className="">
              {honoraries.map((item, idx) => (
                <CarouselItem
                  key={item.name}
                  className="embla__slide basis-9/12 sm:basis-8/12 md:basis-5/12 lg:basis-5/12 xl:basis-1/4"
                >
                  <Fade once={false} delay={idx * 0.2}>
                    <PersonalityCard
                      name={item?.name ?? ""}
                      year={item?.year ?? ""}
                      img={`/assets/personality/${item.year}.png`}
                    />
                  </Fade>
                </CarouselItem>
              ))}
            </CarouselContent>
          </div>
        </Shell>
      </Carousel>
    </Carpet>
  );
}
